import React from 'react';
import { useExperiments } from '@wix/wix-experiments-react';
import { GlobalDesignActionLobbyItem } from '../types';
import { processStyleMetadataForLobby } from '../common/lobby/processStyleMetadataForLobby';
import { CSS_PROPERTIES } from '@wix/component-protocol/schema';
import { LobbyItemLayout } from '../common/lobby/LobbyItemLayout';
import BorderPreview from '../controls/GroupPreview/BorderPreview/BorderPreview';
import { useGroupsPreviewPS } from '../common/lobby/useGroupsPreviewPS';
import { compose } from '../../../apis/services/editActionsServices/nativeActions/globalDesign/common/composer';
import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import { GD_WDS_EXPERIMENT } from '../experiments';

const STROKE_PROPERTY_CONFIG = [
  {
    resultKey: 'stroke',
    mixedKey: 'isMixedStrokeColor',
    atomicKeys: CSS_PROPERTIES.CSS_PROPERTY_TYPE.stroke,
  },
  {
    resultKey: 'strokeWidth',
    mixedKey: 'isMixedStrokeWidth',
    atomicKeys: CSS_PROPERTIES.CSS_PROPERTY_TYPE.strokeWidth,
  },
] as const;

const StrokeLobbyItem: GlobalDesignActionLobbyItem = (props) => {
  const { experiments } = useExperiments({ readOnly: true });
  const isWDS = experiments.enabled(GD_WDS_EXPERIMENT);

  const renderGroupPreviewPS = useGroupsPreviewPS(
    StylesDerivedNativeActions.borderStyles,
    props.group,
  );

  const processedStyleMetadata = processStyleMetadataForLobby(
    props.group.engine,
    STROKE_PROPERTY_CONFIG,
  );

  if (!isWDS) {
    const value = compose('border', {
      borderColor: processedStyleMetadata.stroke[0],
      borderWidth: processedStyleMetadata.strokeWidth[0],
    });

    return (
      renderGroupPreviewPS({
        value,
        emptyPreviewLabel:
          props.group.displayName.group || props.group.displayName.component,
        isMixedBorderColor: processedStyleMetadata.isMixedStrokeColor,
        isMixedBorderWidth: processedStyleMetadata.isMixedStrokeWidth,
        onClick: props.onSelect,
      }) ?? null
    );
  }

  return (
    <LobbyItemLayout
      actionName="borderStyles"
      group={props.group}
      onSelect={props.onSelect}
    >
      <BorderPreview
        colors={processedStyleMetadata.stroke}
        width={processedStyleMetadata.strokeWidth[0]}
        isMixedWidth={processedStyleMetadata.isMixedStrokeWidth}
        emptyPreviewLabel={
          props.group.displayName.group || props.group.displayName.component
        }
      />
    </LobbyItemLayout>
  );
};

export default StrokeLobbyItem;
